import { render, staticRenderFns } from "./ImageQA.vue.js?vue&type=template&id=547f3ad6&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ImageQA.vue?vue&type=template&id=547f3ad6&scoped=true"
import script from "./ImageQA.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ImageQA.vue?vue&type=script&lang=js"
export * from "./ImageQA.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ImageQA.vue?vue&type=script&lang=js"
import style0 from "./ImageQA.vue.css?vue&type=style&index=0&id=547f3ad6&prod&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ImageQA.vue?vue&type=style&index=0&id=547f3ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f3ad6",
  null
  
)

export default component.exports